module.exports = __webpack_public_path__ + "img/pdf.f9b8f93.svg";